// const env = process.env.NODE_ENV || 'production'
const buildEnv = process.env.BUILD_ENV;
const envList = ['offline', 'preline', 'online']
const prodKey = 'ut-xlp';
const publicPathMap = {
  // test: `https://s3-pre-inter.didistatic.com/anythingpre/entry`,
  offline: 'http://10.90.28.42:8082/anythingpre/entry',
  preline: `https://s3-gzpu-inter.didistatic.com/webx/entry`,
  online: `https://ut-static.udache.com/webx/entry`
};

// 兜底静态节点的地址，即之前page.udache.com下的template的部署地址
const staticServerPage = {
  offline: 'http://page-test.intra.xiaojukeji.com/ut-launch-slp/index.html',
  preline: 'https://pre-page.udache.com/ut-launch-slp/index.html',
  online: 'https://page.udache.com/ut-launch-slp/index.html'
};

// 在服务端环境，可能出现与c端环境变量不一致的情况，所以在服务端使用 envlist，staticServerPageMap 等字段，会返回所有环境下的对应静态变量。
module.exports = {
  prodKey,
  env: !buildEnv ? 'offline' : buildEnv,
  envList,

  staticServerPage: staticServerPage[buildEnv || 'offline'],
  staticServerPageMap: staticServerPage,

  publicPath: !buildEnv ? '/' : `${publicPathMap[buildEnv]}/${prodKey}/${buildEnv}`,
  getPublicPathByEnv: env => {
    if (!envList.includes(env)) throw new Error('env 必须为 offline, preline, online 之一')
    return `${publicPathMap[env]}/${prodKey}/${env}`
  },

  templateContext: {
    title: 'Vue App',
    metas: '<!-- inject more metas here -->'
  },

  devConfig: {
    port: 3003
  },
  
  shouldPrefetch: (file, type) => {
    const reg = /ut-launch-ui-(\d)+.[0-9a-fA-F]{16}.js$/;
    if (type === 'script' && !reg.test(file)) {
      // hack ：动态import 的模块添加chuckname，在这里匹配，从prefetch进行排除，避免不必要的资源渲染到html的head中
      return true;
    }
  }
};
